import { atom } from 'recoil'
import { IProtectionTemplate } from '../protection.types'

interface IProtectionTableAtom {
  items: IProtectionTemplate[]
}

const protectionTableAtom = atom<IProtectionTableAtom>({
  key: 'tables/admin/protection-templates',
  default: { items: [] },
})
export default protectionTableAtom
